import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiMaximize2, FiMenu, FiSearch } from "react-icons/fi";
import { logout } from "../../../redux/user/userActions";
import { SocketContext } from "../../../context/socket";
import {
  getNotifications,
  updateNotification,
} from "../../../redux/notifications/notificationsActions";
import { ENVIRONMENT } from "../../../config/keys";
import NavtopProfile from "./components/NavtopProfile";
import NavtopNotifications from "./components/NavtopNotifications";
import Lookup from "../Lookup";

const NavTop = ({ setIsOpen, isOpen, sectionLabel, pageLabel }) => {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);
  const [isLookup, setIsLookup] = useState(false);

  const userInfo = useSelector((state) => state.userState.userInfo);
  const { notifications, updatedId } = useSelector((state) => state.notificationState);
  const userId = userInfo?.id;
  const userRole = userInfo?.role;

  useEffect(() => {
    if (!userId) return undefined;

    const handleNewOrderProduct = (merchantId) => {
      if (userRole === "ROLE_MERCHANT" && merchantId === userId) {
        dispatch(getNotifications(userId));
      }
    };
    const handleOrderUpdate = () => dispatch(getNotifications(userId));

    socket.on("newOrderProduct", handleNewOrderProduct);
    socket.on("updateOrderProduct", handleOrderUpdate);
    dispatch(getNotifications(userId));

    return () => {
      socket.off("newOrderProduct", handleNewOrderProduct);
      socket.off("updateOrderProduct", handleOrderUpdate);
    };
  }, [dispatch, socket, updatedId, userId, userRole]);

  const markNotification = (notification) => {
    if (notification.isSeen === false) dispatch(updateNotification(notification._id));
  };

  const fullScreenHandler = async () => {
    if (document.fullscreenElement) await document.exitFullscreen();
    else if (document.documentElement.requestFullscreen) await document.documentElement.requestFullscreen();
  };

  return (
    <>
      <Lookup setisLookup={setIsLookup} isLookup={isLookup} />
      <header className="dashboard-topbar">
        <div className="dashboard-topbar__left">
          <button type="button" className="dashboard-topbar__menu" onClick={() => setIsOpen(!isOpen)} aria-label="Open navigation">
            <FiMenu />
          </button>
          <div className="dashboard-topbar__context">
            <small>{sectionLabel || "Dashboard"}</small>
            <strong>{pageLabel || "Dashboard"}</strong>
          </div>
        </div>

        <div className="dashboard-topbar__actions">
          <button type="button" className="dashboard-topbar__search" onClick={() => setIsLookup(true)} aria-label="Search dashboard">
            <FiSearch /><span>Search dashboard</span><kbd>⌘ K</kbd>
          </button>
          <span className={`dashboard-environment-badge ${ENVIRONMENT === "local" ? "is-local" : ""}`}>{ENVIRONMENT}</span>
          <button type="button" className="dashboard-topbar__icon is-fullscreen" onClick={fullScreenHandler} title="Fullscreen" aria-label="Fullscreen">
            <FiMaximize2 />
          </button>
          <NavtopNotifications markNotification={markNotification} notifications={notifications} />
          <NavtopProfile userInfo={userInfo} handleLogout={() => dispatch(logout())} />
        </div>
      </header>
    </>
  );
};

export default NavTop;
